<template>
	<div v-loading="loading" class="main-content">
		<div v-if="!loading" class="main-content-inner">
			<div class="container-fluid">
				<div class="row">
					<div class="col-lg-12 content-margin">
						<div class="content">
							<div class="content-header">
								<h2>
									Add user
								</h2>
							</div>
							<div class="content-body">
								<el-form @submit.prevent.native="handleSubmit('form')" :model="form" :rules="rules" ref="form">
									<div class="row">
										<div class="col-lg-6 col-sm-12">
											<el-form-item label="Role" prop="role">
												<el-select v-model="form.role" placeholder="Select role">
													<el-option v-for="(item, index) in roles" :key="index" :label="item.name" :value="item.id"></el-option>
												</el-select>
											</el-form-item>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6 col-md-12">
											<el-form-item label="First name" prop="first_name">
												<el-input type="text" v-model="form.first_name" placeholder="Please enter first name"></el-input>
											</el-form-item>
										</div>
										<div class="col-lg-6 col-md-12">
											<el-form-item label="Last name" prop="last_name">
												<el-input type="text" v-model="form.last_name" placeholder="Please enter last name"></el-input>
											</el-form-item>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6 col-md-12">
											<el-form-item label="Email" prop="email">
												<el-input type="email" v-model="form.email" placeholder="Please enter email"></el-input>
											</el-form-item>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6 col-md-12">
											<el-form-item label="Password" prop="password">
												<el-input type="password" v-model="form.password" placeholder="Please enter password"></el-input>
											</el-form-item>
										</div>
										<div class="col-lg-6 col-md-12">
											<el-form-item label="Password confirmation" prop="password_confirmation">
												<el-input type="password" v-model="form.password_confirmation" placeholder="Please confirm password"></el-input>
											</el-form-item>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6 col-md-12">
											<el-form-item>
												<el-button native-type="submit" type="primary" plain>Save</el-button>
												<el-button plain @click="handleCancel()">Cancel</el-button>
											</el-form-item>
										</div>
									</div>
								</el-form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { HTTP } from '@/services/api'
import { mapState } from 'vuex'

export default {
	name: 'UserAdd',
	metaInfo () {
		return {
			title: 'Add user',
		}
	},
	data () {
        return {
			loading: true,
			roles: [],
			form: {
				first_name: null,
				last_name: null,
				email: null,
				role: null,
				password: null,
				password_confirmation: null,
			},
			rules: {
				role: [
					{ required: true, message: 'Please choose user role', trigger: 'blur' },
				],
				first_name: [
					{ required: true, message: 'Please enter first name', trigger: 'blur' },
				],
				last_name: [
					{ required: true, message: 'Please enter last name', trigger: 'blur' },
				],
				email: [
					{ required: true, message: 'Please enter email', trigger: 'blur' },
					{ type: 'email', message: 'Please enter correct email', trigger: 'blur' }
				],
				password: [
					{ required: true, message: 'Please enter password', trigger: 'blur' },
					{ min: 8, message: 'Password must have at least 8 characters', trigger: 'blur' },
				],
				password_confirmation: [
					{ required: true, message: 'Please confirm password', trigger: 'blur' },
					{ min: 8, message: 'Password must have at least 8 characters', trigger: 'blur' },
				]
			}
        }
    },
	computed: {
        ...mapState(['user'])
	},
	mounted () {
		if (parseInt(this.user.role) !== 1) {
			this.handleCancel()
		} else {
			this.loadRoles()
		}
	},
	methods: {
		loadRoles () {
			return HTTP({
				method: 'GET',
				url: '/roles/',
				crossdomain: true
			})
			.then(response => {
				this.roles = response.data
				this.loading = false
			})
			.catch(error => {
				this.loading = false
				this.$notify({
					title: 'Error',
					message: error.response.data.status ? error.response.data.status : 'An error occured, please try later',
					type: 'error',
					position: 'bottom-right',
					duration: 3500
				})
			})
		},
		handleCancel () {
			this.$router.push('/users')
		},
		handleSubmit (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true
					return HTTP({
						method: 'POST',
						url: '/users',
						crossdomain: true,
						data: this.form
					})
					.then(() => {
						this.loading = false
						this.$router.push('/users')
						this.$notify({
							title: 'Success',
							message: 'User has been created',
							type: 'success',
							position: 'bottom-right',
							duration: 2500
						})
					})
					.catch(error => {
						this.loading = false
						this.$notify({
							title: 'Error',
							message: error.response.data.status ? error.response.data.status : 'An error occured, please try later',
							type: 'error',
							position: 'bottom-right',
							duration: 3500
						})
					})
				} else {
					return false
				}
			})
		}
	}
}
</script>
